export function HStack(props: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  const className = `d-flex flex-row ${props.className}`
  return <div {...props} className={className}></div>
}

export function VStack(props: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  const className = `d-flex flex-column ${props.className}`
  return <div {...props} className={className}></div>
}
